import React from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from './Navbar';
import Footer from './Footer';

const Privacy = () => {
  const { t } = useTranslation();

  return (
    <div className="bg-white text-black min-h-screen font-mono">
    

      <div className="max-w-3xl mx-auto px-6 py-16 border-l-4 border-black">
        <h1 className="text-3xl font-extrabold uppercase border-b-4 border-black pb-2 mb-10">
          {t('privacy.title')}
        </h1>

        <section className="space-y-6 tracking-wide leading-relaxed">
          <p className="border-l-2 border-black pl-4">{t('privacy.point1')}</p>
          <p className="border-l-2 border-black pl-4">{t('privacy.point2')}</p>
          <p className="border-l-2 border-black pl-4">
            {t('privacy.point3')}{' '}
            <a href="/contact" className="underline text-black hover:bg-yellow-300 transition px-1">
              {t('privacy.contactLink')}
            </a>.
          </p>
        </section>
      </div>

     
    </div>
  );
};

export default Privacy;
